import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@instructure/ui-buttons';
import { omitProps } from '@instructure/ui-react-utils';
export var ContextualIconButton = /*#__PURE__*/function (_Component) {
  function ContextualIconButton() {
    var _this;
    _classCallCheck(this, ContextualIconButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ContextualIconButton, [].concat(args));
    _defineProperty(_this, "handleClick", function () {
      var _this$props;
      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }
      (_this$props = _this.props).onClick.apply(_this$props, params.concat([_this.props.context]));
    });
    return _this;
  }
  _inherits(ContextualIconButton, _Component);
  return _createClass(ContextualIconButton, [{
    key: "render",
    value: function render() {
      var buttonProps = omitProps(this.props, {}, ['context', 'onClick']);
      return /*#__PURE__*/React.createElement(IconButton, Object.assign({}, buttonProps, {
        withBackground: false,
        withBorder: false,
        onClick: this.handleClick
      }), this.props.children);
    }
  }]);
}(Component);
_defineProperty(ContextualIconButton, "propTypes", _objectSpread(_objectSpread({}, IconButton.propTypes), {}, {
  context: PropTypes.any
}));
_defineProperty(ContextualIconButton, "defaultProps", _objectSpread(_objectSpread({}, IconButton.defaultProps), {}, {
  context: void 0
}));